import {
  initialState,
  Actions,
  State,
  GET_NOTIFICATIONS_METRICS,
  GET_NOTIFICATIONS_METRICS_SUCCESS,
  GET_NOTIFICATIONS_METRICS_ERROR,
  RESET_GET_NOTIFICATIONS_METRICS,
} from '../../types/notification/get-metrics'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_NOTIFICATIONS_METRICS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_NOTIFICATIONS_METRICS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_NOTIFICATIONS_METRICS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_NOTIFICATIONS_METRICS:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
